import { combineReducers } from '@reduxjs/toolkit'
import { removeLoginToken } from '../../utils/storageUtils'
import { ANTETREK_POPUP_INITIAL_STATE } from '../../utils/antetrek'

import loginReducer from './login'
import casinoMenuReducer from './casinoMenu'
import transactions from './transactions'
import bonusReducer from './bonus'
import limitsReducer from './limits'
import cmsReducer from './cms'
import languageReducer from './language'
import loaderReducer from './loader'
import userReducer from './user'
import paymentReducer from './payment'
import tournamentReducer from './tournament'
import uiConfigReducer from './ui-config'
import modalReducer from './modal'
import calendarReducer from './calendar'

export const resetState = () => ({
  type: 'resetState'
})

const appReducer = combineReducers({
  login: loginReducer,
  user: userReducer,
  casinoMenu: casinoMenuReducer,
  bonus: bonusReducer,
  limits: limitsReducer,
  cms: cmsReducer,
  language: languageReducer,
  transactions,
  loader: loaderReducer,
  payment: paymentReducer,
  tournament: tournamentReducer,
  uiConfig: uiConfigReducer,
  modal: modalReducer,
  calendar: calendarReducer
})

const rootReducer = (state, action) => {
  if (action.type === 'resetState') {
    removeLoginToken()
    return appReducer({
      ...state,
      modal: { modals: [] },
      login: {
        ...state?.login,
        isLoggedIn: false,
        success: false
      },
      user: {
        ...state?.user,
        userDetails: null,
        antetrekPopup: { ...ANTETREK_POPUP_INITIAL_STATE }
      },
      bonus: {
        ...state?.bonus,
        loyaltyDetails: null
      }
    }, action)
  }

  return appReducer(state, action)
}

export default rootReducer
